import { useContext, useEffect, useState } from 'react'
import { StakeContext } from '../context'
import { useInventory } from './useInventory'

const UPDATE_INTERVAL = 1000

/**
 * All-time BR1 Points earned by activating inventory, ticking live.
 *
 * The server figure is a snapshot; between refetches we extrapolate from the current rate so the
 * number visibly moves while items are active. `rate` is per day, so divide down to per second.
 */
export const usePoints = () => {
    const { points: serverPoints } = useContext(StakeContext)
    const { rate } = useInventory()
    const [points, setPoints] = useState(serverPoints?.epoch_points ?? 0)

    useEffect(() => {
        setPoints(serverPoints?.epoch_points ?? 0)
    }, [serverPoints])

    useEffect(() => {
        if (!rate) return
        const perSecond = rate / 60 / 60 / 24
        const timer = setInterval(() => setPoints((prev) => prev + perSecond), UPDATE_INTERVAL)
        return () => clearInterval(timer)
    }, [rate])

    return { points, rate }
}
